import React from "react";
import { Provider } from "react-redux";
import { Store } from "redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import {
  AuthProvider,
  AnalyticsProvider,
  ErrorTrackingProvider,
  Authenticator,
} from "component-library";
import { IApplicationState } from "app/store";
import {
  BASE_PATH,
  CHECKOUT_PATH,
  CHECKOUT_COMPLETE_PATH,
  ACCOUNT_SETTINGS_PATH,
  MY_DETAILS_PATH,
  MY_LOGIN_DETAILS_PATH,
  MY_SUBSCRIPTION_PATH,
  GRAD_TRANSFER_PATH,
} from "config/common";
import config from "config/global";
import ErrorBoundary from "app-shell/ErrorBoundary/ErrorBoundary";
import { GoogleTagManager } from "app-shell/GoogleTagManager/GoogleTagManager";
import Page404Container from "app-shell/Page404Container/Page404Container";
import App from "../../App";
import IndexPage from "pages/IndexPage/MyAccountPage";
import Checkout from "pages/Checkout";
import CheckoutComplete from "pages/CheckoutComplete";
import AccountSettings from "pages/AccountSettings";
import MyDetails from "pages/AccountSettings/MyDetails";
import LoginDetails from "pages/AccountSettings/LoginDetails/LoginDetails";
import MySubscriptions from "pages/MySubscriptions";
import TransferProfilePage from "pages/TransferProfilePage";

interface IRootProps {
  store: Store<IApplicationState>;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path={BASE_PATH} element={<App />}>
        <Route index element={<IndexPage />} />

        {/* Checkout routes: /myhome/checkout/:type */}
        <Route path={CHECKOUT_PATH}>
          <Route index element={<Checkout />} />
          <Route path={CHECKOUT_COMPLETE_PATH} element={<CheckoutComplete />} />
        </Route>

        {/* Account settings routes: /myhome/account-settings */}
        <Route path={ACCOUNT_SETTINGS_PATH}>
          <Route index element={<AccountSettings />} />
          <Route path={MY_DETAILS_PATH} element={<MyDetails />} />
          <Route path={MY_LOGIN_DETAILS_PATH} element={<LoginDetails />} />
          <Route path={MY_SUBSCRIPTION_PATH} element={<MySubscriptions />} />
        </Route>

        {/* Graduate transfer: /myhome/graduate-transfer/information */}
        <Route path={GRAD_TRANSFER_PATH} element={<TransferProfilePage />} />
      </Route>
      <Route path="*" element={<Page404Container />} />
    </>
  )
);

class Root extends React.Component<IRootProps> {
  public render() {
    return (
      <Provider store={this.props.store}>
        <ErrorBoundary>
          <AuthProvider>
            <Authenticator>
              <AnalyticsProvider>
                <ErrorTrackingProvider appName="user-account-app">
                  <GoogleTagManager {...config.gtm} />
                  <RouterProvider router={router} />
                </ErrorTrackingProvider>
              </AnalyticsProvider>
            </Authenticator>
          </AuthProvider>
        </ErrorBoundary>
      </Provider>
    );
  }
}

export default Root;
